var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFactsheetBrickValue(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 224,
    height: 25,
    viewBox: "0 0 224 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 1.24609H42.1808C43.9629 1.24609 45.6906 1.86055 47.0725 2.98588L69.4372 21.1978C70.8191 22.3231 72.5468 22.9376 74.329 22.9376H161.808C164.302 22.9376 166.643 21.7372 168.098 19.7124L179.054 4.47127C180.51 2.44646 182.851 1.24609 185.345 1.24609H223.113",
    stroke: "#4D3F3F",
    strokeWidth: 2.32409
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFactsheetBrickValue);
export default __webpack_public_path__ + "static/media/factsheetBrickValue.9bb45d81a61b012b036f1d457cb9e01b.svg";
export { ForwardRef as ReactComponent };